import React from "react";
import { ArrowLeft } from "@phosphor-icons/react";
import "./css/PrivacyPolicy.css";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="privacy-page">

      <main className="privacy-content">
        <button className="back-button" onClick={() => navigate(-1)}>
          <ArrowLeft size={24} weight="bold" />
          <span>Back</span>
        </button>

        <h1>Privacy Policy</h1>
        <p>
          <strong>Last Updated: April 14th 2026</strong>
        </p>

        <h2>Your Privacy Matters to Us</h2>
        <p>
          Ravooka, referred to as "the Company," "we," or "us," and its
          subsidiaries respect your privacy. This Privacy Policy outlines how
          your data is collected and used by Ravooka. We encourage you to
          carefully read this Privacy Policy. By accessing the services provided
          by Ravooka, you agree to the collection and use of your data as
          described in this Privacy Policy.
        </p>

        <p>
          If you have any questions or concerns regarding this statement, please
          contact us at sup@ravooka.com
        </p>

        <h2>Scope</h2>
        <p>
          This Privacy Policy does not apply to procedures and practices
          followed by entities that are not managed, owned, or controlled by
          Ravooka, or to individuals who are not engaged, employed, or managed
          by Ravooka. Ravooka provides advertising services used by websites 
          through its WordPress plugin.
        </p>

        <h2>1. Information We Collect</h2>
        <ul>
          <li>When Ravooka advertisements are loaded on a website, 
            we may collect the following information:</li>
          <li>IP address</li>
          <li>Approximate geographic location (such as country or region, derived from IP)
          </li>
          <li>
            Device and browser information (user agent)
          </li>
          <li>
            Page URL and referring URL
          </li>
          <li>
            Ad interaction data (such as impressions and clicks)
          </li>
        </ul>

        <h2>2. How We Use This Information</h2>
        <h3>We use this information to:</h3>
        <ul>
          <li>Deliver and display relevant advertisements</li>
          <li>Measure ad performance and impressions</li>
          <li>Prevent fraud and abuse</li>
          <li>Improve our advertising services</li>
        </ul>


        <h2>3. Cookies</h2>
        <ul>
          <li>
           Ravooka does not use cookies for tracking users.
          </li>
        </ul>

        <h2>Sharing Your Information</h2>
        <p>
          We do not share your financial information except to complete
          transactions. We may share necessary details with agents, shipping
          companies, and alliance partners to fulfill services.
        </p>

        <h2>4. Data Sharing</h2>
        <p>
          We do not sell personal data. 
          Data may be processed by our infrastructure providers strictly for service delivery.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We retain collected data only as long as necessary for providing and improving our services.
        </p>

        <h2>6. Contact</h2>
        <p>
          For privacy-related inquiries, contact:
          sup@ravooka.ai
        </p>

        <h2>Links to Other Sites</h2>
        <p>
          We are not responsible for the privacy practices of linked websites.
        </p>

        <h2>Policy Updates</h2>
        <p>
          We may update this policy at any time. Changes are effective
          immediately upon posting.
        </p>

      </main>
    </div>
  );
};

export default PrivacyPolicy;
